<template>
    <div>
        <span>{{ $t('notification.tablePageUpdated', {
            actor: $_.get(activity, 'actorUser.name'),
            tableName: $_.get(activity, 'payload.tableName'),
            pageName: $_.get(activity, 'payload.pageName')
        }) }}</span>
    </div>
</template>

<script>
export default {
    name: "TablePageUpdated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    }
};
</script>

